// src/services/useDashboardStore.js
import { create } from "zustand";
import { api } from "./api";

export const useDashboardStore = create((set, get) => ({
  // State
  dashboardData: null,
  loading: false,
  error: null,
  lastRefresh: null,

  // Actions
  fetchDashboard: async () => {
    set({ loading: true, error: null });
    try {
      const response = await api.get("/api/dashboard");
      console.log(response);
      set({
        dashboardData: response.data,
        loading: false,
        lastRefresh: new Date(),
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching dashboard:", error);
      set({
        error: error.response?.data?.message || "Failed to fetch dashboard",
        loading: false,
      });
      throw error;
    }
  },

  clearError: () => set({ error: null }),
}));
